export default __webpack_public_path__ + "static/media/pantalon-saco-mujer.0061506f.png";